// Eigenaars van een taak: de chips, weghalen (planner) en toevoegen uit de collega's met hun bezetting deze week, zoals
// op Capaciteit (de minste bezetting eerst). Gedeeld door de taaklade en de taakpagina.
import { useState } from "react";
import { useCapacity } from "../../lib/api-clockify";
import { catOf } from "../../lib/board";
import { useIndex } from "../../lib/hooks";
import { Icon } from "../../lib/icons";
import { useSettings } from "../../lib/settings";
import type { PlanningData, Task, TaskOp } from "../../lib/types";
import { Av } from "../Avatar";
import { loadOf, thresholdsOf, type Load } from "../TaskCard";
import type { TaskPerm } from "./perm";

export function OwnersSection({ task, data, perm, run }: { task: Task; data: PlanningData; perm: TaskPerm; run: (ops: TaskOp[], message: string) => void }) {
  const idx = useIndex(data);
  const settings = useSettings().data?.settings;
  // bezetting: een medewerker ziet ze alleen als Instellingen dat toelaat (anders weigert de server)
  const { data: cap } = useCapacity(!perm.med || perm.rights.seeCapacity);
  const [open, setOpen] = useState(false);
  const th = thresholdsOf(settings);
  const rank = (ld: Load | null) => (!ld ? 1e4 : ld.pct == null ? 2e4 : ld.pct);
  const cands = data.people.filter((p) => !task.owners.some((o) => o.personId === p.id))
    .map((p) => ({ p, n: data.tasks.filter((t) => catOf(t) === "actief" && t.owners.some((o) => o.personId === p.id)).length, ld: open ? loadOf(cap, p.id, th) : null }))
    .sort((a, b) => rank(a.ld) - rank(b.ld) || a.n - b.n);
  return (
    <>
      <div className="p-owners">
        {task.owners.map((o) => {
          const p = idx.people.get(o.personId);
          return (
            <span key={o.personId} className="p-tog on p-owner"><Av id={o.personId} init={p?.initials || "?"} cls="p-av s" />{p?.name || "Onbekend"}
              {perm.plan && <button type="button" className="p-owner-x" aria-label="Eigenaar weghalen" title="Eigenaar weghalen" onClick={() => run([{ kind: "owner", personId: o.personId, on: false }], (p?.first || "Deze persoon") + " is geen eigenaar meer van " + task.title)}><Icon name="x" size={12} /></button>}
            </span>
          );
        })}
        {perm.plan && <button type="button" className="p-tog" aria-expanded={open} onClick={() => setOpen(!open)}><Icon name="plus" size={13} />Eigenaar</button>}
        {!perm.plan && !task.owners.length && <span className="t-mute" style={{ fontSize: 13 }}>Zonder eigenaar</span>}
      </div>
      {open && (
        <div className="p-capc p-ownpick">
          {cands.map(({ p, n, ld }) => (
            <button key={p.id} type="button" className="p-cand" onClick={() => { setOpen(false); run([{ kind: "owner", personId: p.id, on: true }], p.first + " is nu eigenaar van " + task.title); }}>
              <Av id={p.id} init={p.initials} />
              <span><b>{p.name}</b><span className={"p-capc-n " + (!ld ? "t-mute" : ld.pct == null ? "t-err" : ld.textCls || "t-mute")}>{n === 1 ? "1 actieve taak" : n + " actieve taken"}{ld ? " · deze week " + (ld.pct == null ? ld.absent : ld.text + " bezet") : ""}</span></span>
              <span className="p-capc-go">Toevoegen</span>
            </button>
          ))}
        </div>
      )}
    </>
  );
}
